import appAPI from '@/api/AppAPI'

const state = {
  app: null,
  config: null,
  propertyDeveloperId: null
}

const mutations = {
  setApp (state, payload) {
    state.app = payload.app
    state.config = payload.config
    state.propertyDeveloperId = payload.propertyDeveloperId
  }
}

const getters = {
  config (state) {
    return state.config
  },
  propertyDeveloperId (state) {
    return state.propertyDeveloperId
  }
}

const actions = {
  startApp ({ commit }, payload) {
    commit('setLoading', true, { root: true })
    commit('clearError', null, { root: true })
    return new Promise((resolve, reject) => {
      appAPI.startApp(payload, payload.appToken)
        .then(resp => {
          commit('setLoading', false, { root: true })
          commit('setApp', resp.data)
          resolve()
        })
        .catch(error => {
          commit('setLoading', false, { root: true })
          commit('setError', error, { root: true })
          console.log(error)
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
